export const PAGE_VIEW_EVENT = 'page_view';
export const SITE_NAME = 'website-booking';

export const SELECT_SPECIALIST = 'select-specialist';
export const SELECT_SPECIALTY = 'select-specialty';
export const NEW_PATIENT_REGISTRATION = 'new-patient-registration';
export const MEDICARE_AND_HEALTH = 'medicare-and-health';
export const CONFIRM_BOOKING = 'confirm-booking';
export const BOOKING_RESULT = 'booking-result';
